import { useCallback } from "react"
import { graphql, useMutation, UseMutationConfig } from "react-relay"
import { useChDeleteGeneralAttestationMutation as useChDeleteGeneralAttestationMutationType } from "@/modules/patients/detail/general-attestation/ch/services/__generated__/useChDeleteGeneralAttestationMutation.graphql"

const mutation = graphql`
  mutation useChDeleteGeneralAttestationMutation($input: Ch_deleteGeneralAttestationInput!) {
    ch_deleteGeneralAttestation(input: $input) {
      ch_GeneralAttestation {
        id @deleteRecord
      }
    }
  }
`

const useChDeleteGeneralAttestationMutation = () => {
  const [commit, isFlight] = useMutation<useChDeleteGeneralAttestationMutationType>(mutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChDeleteGeneralAttestationMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChDeleteGeneralAttestationMutation }
